import router from '@/router/index.js';
import axios from 'axios';
import { Message } from 'element-ui'
import { getToken } from './common'
const service = axios.create({
  timeout: 5000,
  // baseURL:'https://h.linyouquan.net'//测试
  baseURL:'https://lyy.linyouquan.net' //正式
});
/* 请求拦截器 */
service.interceptors.request.use(
  (config) => {
    if(config.method=='get') {
      if(config.url.indexOf('pc_login.php')>-1) {
        config.withcredentials  = true
      }
    }
    /* 取token */
    let pathname = location.pathname
    const token = getToken();
    if(token) {
      if(pathname != '/' &&  pathname != '/login') {
        config.data = {
          ...config.data,
          token: token
        }
      }
    }
    return config;
  },
  (err) => {
    console.error('请求发生了错误', err);
    return Promise.reject(err);
  }
);

/* 响应拦截器 */
service.interceptors.response.use(
  (res) => {
    if(res.data.code !=200) {
      if(res.data.code == '424') {
        location.pathname = '/login'
        router.push({
          path: '/login',
          //登录成功后跳入浏览的当前页面
          // query: {redirect: router.currentRoute.fullPath}
        })
      }else{
        Message({
          showClose: true,
          message: res.data.message,
          type: 'error'
        });
      }
      return Promise.reject(res.data)
    }else{
      return res;
    }
  },
  (err) => {
    console.error('响应发生了错误', err);
    return Promise.reject(err);
  }
);

export default service;



// WEBPACK FOOTER //
// ./src/utils/service.js